document.addEventListener('DOMContentLoaded', () => {
    //image-banner
    const imageBannerSlider = new Swiper(".image-banner__wrapper", {
        slidesPerView: 1,
        pagination: {
            el: ".image-banner__wrapper .swiper-pagination",
            clickable: true,
        },
    });
});